/**
 * Created by Daniel
 * Description:
 *
 * ---------maintenance history-------------
 * 05/15/2020 Ella add serverSide grid
 */

import { AppState } from '../../redux';
import { ColDef, GridOptions } from 'ag-grid-community';
import { Component, HostListener, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Store, select } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { take, filter } from 'rxjs/operators';

import { DateHelperWebService } from '../../tamalelibs/services/date-helper.web.service';
import { DataList } from '../../tamalelibs/models/data-list.model';
import { FileHelperService } from '../../services/file-helper.service';
import { PriorityStarAggridComponent } from '../../widgets/priority-star-aggrid/priority-star-aggrid.component';
import { QueryInfo, ThreadListConfig, GridColumnInfo, SortInfo } from '../../pages/research/research.view-model';
import { ResearchView } from '../../constants/business.constants';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StoreQuerierService } from '../../services/store-querier.service';
import { NoteService } from '../../services/note.service';
import { systemCurrentContactSelector } from '../../redux/reducers/system.reducer';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { DELETE_NOTE, DELETE_SIDENOTE_SUCCESS, DELETE_ATTACHMENT_SUCCESS, DELETE_NOTES } from '../../tamalelibs/redux/note.actions';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { NoteDialogOpenOptions, NoteDialogType } from '../note-dialog/note-dialog.model';
import { NoteDialogService } from '../note-dialog/note-dialog.service';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { ResearchScreenActionTypes } from '../../redux/actions/research-screen.actions';
import { PrintService } from '../../services/print.service';
import { ResearchScreenService } from '../../services/research-screen.service';
import { ThreadEntry } from '../../tamalelibs/models/thread-entry.model';
import { ShowAsMode } from '../display/display.model';
import { CalendarDialogOpenOptions, CalendarDialogType } from '../calendar-dialog/calendar-dialog.model';
import { CalendarDialogService } from '../calendar-dialog/calendar-dialog.service';
import { PrintActions } from '../print/print.model';
import { MultipleFilesRendererComponent } from '../../widgets/ag-grid/multiple-files-renderer.component';
import { FileDownload } from '../../tamalelibs/models/file-list.model';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { AppendEntitiesDialogOpenOptions, AppendEntitiesDialogType } from '../append-entities-dialog/append-entities-dialog.model';
import { AppendEntitiesDialogService } from '../append-entities-dialog/append-entities-dialog.component.service';

export const DEFAULT_PAGE_SIZE = 100;

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'top-thread-list',
    templateUrl: './top-thread-list.component.html',
    styleUrls: ['./top-thread-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopThreadListComponent implements OnInit, OnDestroy {
    @Input() config: ThreadListConfig;
    @Input() collapseSuject: Subject<any> = new Subject();

    columnDefs: Array<ColDef>;
    gridOptions: GridOptions;
    loadingMore = false;
    reloading = false;
    selectedIndexes: Set<number> = new Set();
    selectedIndex: number;
    noDataStyle = 'none';
    threadEntryList: DataList<ThreadEntry> = new DataList<ThreadEntry>();
    contextMenuConfig: ContextMenuConfig;
    groupContextMenuConfig: ContextMenuConfig;
    isIPAD = false;

    rowModelType = 'clientSide';
    gridServerSideLayout;
    gridServerSideAction$ = new Subject();
    gridServerSideFeedback$ = new Subject();

    private _destroySubscriptions: Array<Subscription> = [];
    private _destroyInitSubscriptions: Array<Subscription> = [];
    private _currentPageIndex = 1;
    private _currentUser: SystemUser;
    private _columnState: any;
    private _gridColumnApi;
    private _gridApi;
    private _isAdminUser = false;
    private _isComplianceUser = false;
    private _overlayNoRowsTemplate = '<span style=\'font-size: 20px;background-color:white;color:black\'>No Data Found</span>';
    private _queryInfo: QueryInfo;
    private _sortInfo: any;
    private _hasDeletePermissionThreadEntryIds: Array<string>;
    private _showAsMode = ShowAsMode.NOTES;
    private _selectedItem: ThreadEntry;
    private _selectedItems: Array<ThreadEntry>;
    private _noSetLoading: boolean;

    constructor(
        private _store: Store<AppState>,
        private _fileHelperService: FileHelperService,
        private _deviceService: DeviceDetectorService,
        private _storeQuerier: StoreQuerierService,
        private _noteService: NoteService,
        private _alertWindow: AlertWindowService,
        private _noteDialogService: NoteDialogService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _printService: PrintService,
        private _researchScreenService: ResearchScreenService,
        private _calendarDialogService: CalendarDialogService,
        private _datepipe: DatePipe,
        private _appendEntitiesDialogService: AppendEntitiesDialogService,
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        if (this._currentUser && this._currentUser.credential) {
            this._isAdminUser = this._currentUser.credential.admin;
            this._isComplianceUser = this._currentUser.credential.compliance;
        }

        // Defining data for columns
        this.columnDefs = [
            {
                headerName: 'Sentiment',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/positive_negative.svg" style="width:16px;height:16px;"></image>'
                },
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.threadEntrySentiment;
                    }
                    return '';
                },
                headerClass: 'icon-header-style',
                cellRenderer: function (params) {
                    const imageElement = document.createElement('img');
                    imageElement.width = 13;
                    imageElement.height = 13;
                    if (params && params.value) {
                        if (params.value === 1) {
                            imageElement.src = './assets/images/singlesvg/positive-header.svg';
                            return imageElement;
                        } else if (params.value === -1) {
                            imageElement.src = './assets/images/singlesvg/negative-header.svg';
                            return imageElement;
                        } else {
                            return '';
                        }
                    }
                },
                colId: 'sentiment',
                menuTabs: [],
                width: 32,
                minWidth: 32,
                maxWidth: 32,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px',
                    'text-overflow': 'unset'
                }
            },
            {
                headerName: 'Attachments',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/attachment.svg" style="width:16px;height:16px;"></image>'
                },
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.attachments;
                    }
                },
                headerClass: 'icon-header-style',
                cellRenderer: (params) => {
                    const imageElement = document.createElement('img');
                    imageElement.width = 14;
                    imageElement.height = 14;
                    if (params && params.data && params.data.threadEntryAttachments) {
                        if (params.data.threadEntryAttachments.size > 1) {
                            imageElement.src = './assets/images/singlesvg/attachment.svg';
                            return imageElement;
                        } else if (params.data.threadEntryAttachments.size === 1) {
                            const extension = Array.from(params.data.threadEntryAttachments)[0][1].extension;
                            const iconFileName = this._fileHelperService.getIconFileName(extension);
                            imageElement.src = './assets/images/singlesvg/' + iconFileName;
                            return imageElement;
                        } else {
                            return '';
                        }
                    }
                },
                colId: 'attachments',
                menuTabs: [],
                width: 32,
                minWidth: 32,
                maxWidth: 32,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px',
                    'text-overflow': 'unset'
                }
            },
            {
                headerName: 'Entities',
                valueGetter: (params) => {
                    let entitiesName = '';
                    if (params.data && params.data.parentEntry
                        && params.data.parentEntry.entities
                        && params.data.parentEntry.entities.length > 0) {
                        params.data.parentEntry.entities.forEach(entity => {
                            entitiesName = entitiesName + entity.shortName + ', ';
                        });
                        return entitiesName.substring(0, entitiesName.length - 2);
                    }
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'entity',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50
            },
            {
                headerName: 'Type',
                valueGetter: (params) => {
                    if (params.data && params.data.threadEntryType) {
                        return params.data.threadEntryType.name;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                field: 'entrytype',
                colId: 'entrytype',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50
            },
            {
                headerName: 'Subject',
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.threadEntryCalculatedSubject;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'title',
                menuTabs: ['columnsMenuTab'],
                minWidth: 100
            },
            {
                headerName: 'Source',
                valueGetter: (params) => {
                    if (params.data && params.data.threadEntrySource) {
                        return params.data.threadEntrySource.shortName;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'source',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50
            },
            {
                headerName: 'Display Date',
                valueGetter: (params) => {
                    return params.data ? params.data.displayDate : '';
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'displayDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc'],
                sort: 'desc'
            },
            {
                headerName: 'Sidenotes',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/sidenote.svg" style="width:13px;height:13px;margin-top:7.5px;"></image>'
                },
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    if (params.data.threadEntryParseByThread) {
                        if (params.data.parentEntry.totalNotesInThread > 1) {
                            return params.data.parentEntry.totalNotesInThread - 1;
                        }
                    } else {
                        const totalNotesInThread = params.data.threadEntryTotalNotesInThread;
                        if (totalNotesInThread > 1) {
                            const notePostionInThread = params.data.threadEntryThreadPosition + 1;
                            return notePostionInThread + '/' + totalNotesInThread;
                        }
                    }
                },
                headerClass: 'icon-header-style',
                colId: 'sidenotes',
                menuTabs: [],
                suppressSizeToFit: true,
                width: 48,
                minWidth: 48,
                maxWidth: 48,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px'
                }
            },
            {
                headerName: 'Last Modified Date',
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    return params.data.lastEditedDate;
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                hide: true,
                colId: 'lastModifiedDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc']
            },
            {
                headerName: 'Submitted Date',
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    return params.data.submittedDate;
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                hide: true,
                colId: 'submittedDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc'],
            },
            {
                headerName: 'Submitter',
                valueGetter: 'data.threadEntrySubmitter.shortName',
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'submitter',
                hide: true,
                menuTabs: ['columnsMenuTab'],
                minWidth: 60
            },
            {
                headerName: 'Priority',
                valueGetter: 'data.threadEntryPriority',
                cellRenderer: PriorityStarAggridComponent,
                colId: 'priority',
                hide: true,
                menuTabs: ['columnsMenuTab'],
                width: 70,
                sortable: false,
                resizable: false,
            },
            {
                headerName: 'Filename',
                cellRenderer: MultipleFilesRendererComponent,
                cellRendererParams(params) {
                    const files = Array.from(params.data.threadEntryAttachments.values()).map(item => {
                        const data = new FileDownload(item['serverFileName'], item['fileName'], item['extension']);
                        return data;
                    });
                    return { files: files };
                },
                colId: 'filename',
                menuTabs: ['columnsMenuTab'],
                hide: true,
                minWidth: 80
            }
        ];

        this.gridOptions = {
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            animateRows: true,
            paginationAutoPageSize: true,
            suppressMultiSort: true,
            cacheBlockSize: ResearchView.cacheBlockSize,
            rowGroupPanelShow: 'always',
            colResizeDefault: 'shift',
            suppressCellFocus: true,
            suppressColumnVirtualisation: true,
            enableBrowserTooltips: true,
            enableCellChangeFlash: true,
            paginationPageSize: DEFAULT_PAGE_SIZE,
            rowSelection: 'multiple', // set it for print function.
            sortingOrder: ['asc', 'desc'],
            maintainColumnOrder: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true,
            suppressRowGroupHidesColumns: true,
            overlayNoRowsTemplate: this._overlayNoRowsTemplate,
            rowMultiSelectWithClick: true,
            getRowStyle: (params) => {
                if (this._selectedItem) {
                    if (params.node.data.threadEntryThreadId === this._selectedItem.threadEntryThreadId) {
                        return {
                            background: '#e7eff5',
                        };
                    } else {
                        return {};
                    }
                }
            }
        };

        if (this.collapseSuject) {
            this.collapseSuject.subscribe(event => {
                this._gridColumnAutoFit();
            });
        }
        this._showAsMode = this.config.showAsMode;
        this._initContextMenu();
        this.initGroupContextMenu();
        this._destroyInitSubscriptions.push(
            this._store.pipe(
                select(this.config.threadListGridGroupLayoutSelector),
            ).subscribe(data => {
                this._onSubscribeGridGroupLayout(data);
            }),
            this.gridServerSideFeedback$.subscribe((event) => {
                this._gridServerSideFeedback(event);
            }),
            // Changed data in store when conditions change
            this.config.actions$.subscribe(action => this._onSubscribeActions(action)),
            // filter out all empty subscription
            this._store.pipe<string>(select('noteMsg'))
                .pipe(filter(res => res && res.length > 0))
                .subscribe(res => this._onSubscribeNoteMsg(res)),
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action))
        );
        // handle re-initialize during layout change
        this._store.pipe(
            select(this.config.queryInfoSelector),
            take(1)
        ).subscribe(queryInfo => this._queryInfo = queryInfo);

        // get the sort info from store
        this._store.pipe(
            select(this.config.sortInfoSelector),
            take(1)
        ).subscribe(sortInfo => this._sortInfo = sortInfo);
        this._changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this.contextMenuConfig.events$.unsubscribe();
        this.groupContextMenuConfig.events$.unsubscribe();
        this._destroyInitSubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    suppressDefaultContextMenu(event) {
        // agGrid bug, we need to handle this
        event.preventDefault();
        event.stopPropagation();
    }

    onBodyScroll(e) {
        if (this.threadEntryList.hasNext && !this.loadingMore && e.api.gridBodyCtrl) {
            if (e.top + e.api.gridBodyCtrl.eBodyViewport.clientHeight + 1000 > e.api.gridBodyCtrl.eBodyViewport.scrollHeight) {
                this.loadingMore = true;
                this._currentPageIndex++;
                this._store.dispatch({
                    prefix: this.config.keyInStore,
                    type: this.config.loadMoreAction,
                    payload: {
                        pageIndex: this._currentPageIndex,
                        pageSize: DEFAULT_PAGE_SIZE,
                        showAsMode: this._showAsMode,
                        ...this._queryInfo
                    }
                });
                this._changeDetectorRef.detectChanges();
            }
        }
    }

    onColumnVisible() {
        this._saveState();
    }

    onColumnResized(e) {
        if (e.source === 'uiColumnDragged' && e.finished) {
            this._saveState();
        }
    }

    onColumnMoved(e) {
        if (e.source === 'uiColumnDragged') {
            this._saveState();
        }
    }

    onContextMenu(event) {
        this._selectedItems = this._researchScreenService.getSelectedItems(this.threadEntryList, this.selectedIndexes);
        const index = event.rowIndex;
        if (this.isIPAD) {
            event.event.clientX = event.event.pageX;
            event.event.clientY = event.event.pageY;
        }
        if (this.selectedIndexes.size > 1) {
            this.contextMenuConfig.items = [];
            if (!this.isIPAD) {
                this._hasDeletePermissionThreadEntryIds = this._researchScreenService.getHasDeletePermissionThreadEntryIds(this._selectedItems);
                if (this._hasDeletePermissionThreadEntryIds && this._hasDeletePermissionThreadEntryIds.length > 0) {
                    this.contextMenuConfig.items.push({ id: '6', text: 'Delete notes', disabled: false });
                }
                this.contextMenuConfig.items.push({ id: '8', text: 'Print (type "p")', disabled: false });
            }
            if (this._isAdminUser && this._isComplianceUser) {
                this.contextMenuConfig.items.push({ id: '9', text: 'Append entity(s)', disabled: false });
            }
        } else {
            this._changeSelect(this.threadEntryList[index], index);
            if (this.rowModelType === 'clientSide') {
                this._changeSelectStyle();
            }
            this.contextMenuConfig.items = [];
            this.contextMenuConfig.items.push({ id: '0', text: 'Open note in new tab', disabled: false });
            this.contextMenuConfig.items.push({ id: '1', text: 'Open note in new window', disabled: false });
            this.contextMenuConfig.items.push({ divider: true });
            this.contextMenuConfig.items.push({ id: '2', text: 'Add sidenote', disabled: false });

            if (event.data.threadEntryEditable) {
                this.contextMenuConfig.items.push({ id: '3', text: 'Edit note', disabled: false });
            }
            if (this.isIPAD) {
                if (event.data.threadEntryDeleable) {
                    this.contextMenuConfig.items.push({ id: '4', text: 'Copy link', disabled: false });
                }
            } else {
                this.contextMenuConfig.items.push({ id: '4', text: 'Copy link', disabled: false });
            }
            if (!this.isIPAD) {
                this.contextMenuConfig.items.push({ id: '5', text: 'Email note', disabled: false });
            }
            if (event.data.threadEntryDeleable) {
                this.contextMenuConfig.items.push({ id: '6', text: 'Delete note', disabled: false });
            }
            this.contextMenuConfig.items.push({ id: '7', text: 'Maximize view', disabled: false });
            if (!this.isIPAD) {
                this.contextMenuConfig.items.push({ id: '8', text: 'Print (type "p")', disabled: false });
            }
            if (this._isAdminUser && this._isComplianceUser) {
                this.contextMenuConfig.items.push({ id: '9', text: 'Append entity(s)', disabled: false });
            }
        }
        this._changeDetectorRef.detectChanges();
        this.contextMenuConfig.show$.next(new ContextMenuShowAction(event.event, event.data));
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        if (this.rowModelType === 'clientSide') {
            if (this._gridApi) {
                this._gridApi.sizeColumnsToFit();
            }
        } else {
            this.gridServerSideAction$.next({
                type: 'WINDOW_RESIZE'
            });
        }
        this._changeDetectorRef.detectChanges();
    }

    onRowDoubleClicked(event) {
        // double click didn't handle any data process logic as it will trigger click first
        // and click event handler will process data
        if (event.event.ctrlKey || event.event.metaKey || event.event.shiftKey) {
            return;
        }

        const item = event.api.getSelectedNodes()[0];
        this.config.events$.next({
            type: 'DOUBLE_CLICK',
            payload: item
        });
    }

    onRowSelected(event) {
        const index = event.rowIndex;
        if (this.selectedIndexes.size === 1 && this.selectedIndexes.has(index)) {
        } else if (event.event.shiftKey) { // shift first
            let firstSelectedEntryIndex = this.selectedIndex;
            let secondSelectedEntryIndex = index;
            if (firstSelectedEntryIndex > secondSelectedEntryIndex) {
                const tempIndex = firstSelectedEntryIndex;
                firstSelectedEntryIndex = secondSelectedEntryIndex;
                secondSelectedEntryIndex = tempIndex;
            }
            let entryIndex = -1;
            for (entryIndex = firstSelectedEntryIndex; entryIndex <= secondSelectedEntryIndex; ++entryIndex) {
                this.selectedIndexes.add(entryIndex);
            }
            this._selectedItem = null;
            this._redrawRows();
        } else if (event.event.ctrlKey || event.event.metaKey) { // handle command key in MAC book
            // select and de-select
            if (this.selectedIndexes.has(index)) {
                this.selectedIndexes.delete(index);
            } else {
                this.selectedIndexes.add(index);
            }
            if (this.selectedIndexes.size === 1) {
                this._selectedItem = this.threadEntryList[index];
            } else {
                this._selectedItem = null;
            }
            this._redrawRows();
        } else {
            this._selectedItem = this.threadEntryList[index];
            this._redrawRows();

            this._changeSelect(this.threadEntryList[index], index);
            if (this.rowModelType === 'clientSide') {
                this._changeSelectStyle();
            }
            return;
        }
        if (this.rowModelType === 'clientSide') {
            this._changeSelectStyle();
        }
    }

    onGridReady(params) {
        this._gridApi = params.api;
        this._gridColumnApi = params.columnApi;
        this._initSubscriptions();

        // assign sort info for ag-grid
        let sort = [{
            colId: 'displayDate',
            sort: 'desc'
        }];
        if (this._sortInfo && JSON.stringify(this._sortInfo) !== '{}') {
            sort = [{
                colId: this._sortInfo.sortBy,
                sort: this._sortInfo.sortOrder
            }];
        }
        this._gridColumnApi.applyColumnState({ state: sort, defaultState: { sort: null } });

        params.api.sizeColumnsToFit();
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);

        this._restoreState();
        this._changeDetectorRef.detectChanges();
    }

    initGroupContextMenu() {
        const contextMenuConfig = new ContextMenuConfig();
        contextMenuConfig.stateful = false;
        contextMenuConfig.showItemIcon = false;
        contextMenuConfig.items = [
            { id: 'NoteType', text: 'Group by Note Type', disabled: false },
        ];
        contextMenuConfig.events$.subscribe(event => {
            if (event.payload.id === 'NoteType') {
                this._setGridRowModelType('serverSide');
            }
        });
        this.groupContextMenuConfig = contextMenuConfig;
    }

    @HostListener('window:keydown', ['$event'])
    onKeydown(event) {
        // use up/down arrow keys to select through items
        if (event.keyCode === 40) { // down
            // get the index of last selected item
            let nextIndex = 0;
            Array.from(this.selectedIndexes.values()).forEach(index => {
                if (index > nextIndex) {
                    nextIndex = index;
                }
            });
            if (++nextIndex < this.threadEntryList.length) {
                const mockEvent: any = {
                    rowIndex: nextIndex,
                    event: event,
                };
                this.onRowSelected(mockEvent);
            }
        } else if (event.keyCode === 38) { // up
            // get the index of first selected item
            const indexArr = Array.from(this.selectedIndexes.values());
            let nextIndex = indexArr[0];
            indexArr.forEach(index => {
                if (index < nextIndex) {
                    nextIndex = index;
                }
            });
            if (--nextIndex > -1) {
                const mockEvent: any = {
                    rowIndex: nextIndex,
                    event: event,
                };
                this.onRowSelected(mockEvent);
            }
        }
    }

    onPostProcessPopup(params) {
        if (params.type !== 'columnMenu') {
            return;
        }
        // set a fix height for popup column menu
        const ePopup = params.ePopup;
        ePopup.style.top = '34px';
    }

    showContextMenu(e: MouseEvent) {
        this.groupContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    onSortChanged(e) {
        const columnState = this._gridColumnApi.getColumnState();
        const sortModel = columnState
            .filter(column => column.sort)
            .map(column => ({ colId: column.colId, sort: column.sort }));

        if (sortModel && sortModel.length > 0) {
            // get sort information
            if (!this._sortInfo) {
                this._sortInfo = new SortInfo();
            }
            this._queryInfo.sortBy = this._sortInfo.sortBy = sortModel[0].colId;
            this._queryInfo.sortOrder = this._sortInfo.sortOrder = sortModel[0].sort;

            // init grid status
            this._saveState();
            // change page index
            this._currentPageIndex = 1;
            // trigger reload, for save screen
            this._triggerSortChanged(this._sortInfo);
            this.reloading = true;
            this._store.dispatch({
                prefix: this.config.keyInStore,
                type: this.config.reloadAction,
                payload: {
                    pageIndex: 1,
                    pageSize: DEFAULT_PAGE_SIZE,
                    showAsMode: this._showAsMode,
                    ...this._queryInfo
                }
            });
        }
        this._changeDetectorRef.detectChanges();
    }

    private _setGridRowModelType(rowModelType) {
        this.rowModelType = rowModelType;
        this.selectedIndexes.clear();
        this.selectedIndex = null;
        this._selectedItem = null;
        this.groupContextMenuConfig.items[0].disabled = this.rowModelType === 'serverSide';
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setGridRowModelTypeAction,
            payload: {
                rowModelType,
                expandGroups: null,
                groupSortColumns: null
            }
        });
        this._changeDetectorRef.detectChanges();
    }

    private _initSubscriptions() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        // Loading data
        this._destroySubscriptions.push(
            this._store.pipe(
                select(this.config.threadListItemSelector)
            ).subscribe(items => this._onSubscribeThreadListItem(items)),
        );
        // handle re-initialize during layout change
        this._store.pipe(
            select(this.config.threadListSelector),
            take(1)
        ).subscribe(threadEntryList => {
            this._onSubscribeThreadList(threadEntryList);
        });
    }

    private _gridServerSideFeedback(event) {
        if (event.type === 'CHANGE_ROW_MODEL') {
            this.reloading = true;
            this._noSetLoading = true;
            this._setGridRowModelType('clientSide');
            this._store.dispatch({
                prefix: this.config.keyInStore,
                type: this.config.clearThreadListAction,
            });
            setTimeout(() => {
                this._store.dispatch({
                    prefix: this.config.keyInStore,
                    type: this.config.reloadAction,
                    payload: {
                        pageIndex: 1,
                        pageSize: DEFAULT_PAGE_SIZE,
                        showAsMode: this._showAsMode,
                        ...this._queryInfo
                    }
                });
            });
        } else if (event.type === 'ROW_SELECTED') {
            const index = this.threadEntryList.findIndex(item => item.id === event.payload.data.id);
            if (index !== -1) {
                event.payload.rowIndex = index;
            }
            this.onRowSelected(event.payload);
        } else if (event.type === 'ROW_KEYDOWN') {
            const index = this.threadEntryList.findIndex(item => item.id === event.payload.data.id);
            if (index !== -1) {
                this._changeSelect(event.payload.data, index);
            }
        } else if (event.type === 'ROW_DOUBLE_CLICKED') {
            this.onRowDoubleClicked(event.payload);
        } else if (event.type === 'ROW_CONTEXT_MENU') {
            const selectedIndexes: Set<number> = new Set();
            let firstNote;
            event.notes.forEach((node) => {
                if (!node.group) {
                    const selectedIndex = this.threadEntryList.findIndex(item => item.id === node.data.id);
                    if (!firstNote) {
                        firstNote = node;
                    }
                    selectedIndexes.add(selectedIndex);
                }
            });
            if (selectedIndexes.size > 0) {
                if (selectedIndexes.size === 1) {
                    const index = Array.from(selectedIndexes.values())[0];
                    event.payload.rowIndex = index;
                    event.payload.data = firstNote.data;
                }
                this.selectedIndexes = selectedIndexes;
                this.onContextMenu(event.payload);
            }
        } else if (event.type === 'LOAD_GRID_GROUP_DATA') {
            this._store.dispatch({
                prefix: this.config.keyInStore,
                type: this.config.reloadGroupAction,
                payload: {
                    showAsMode: this._showAsMode,
                    ...this._queryInfo,
                    ...event.payload,
                    ...event.sortInfo
                }
            });
            // todo selected row
            this._sortInfo = event.sortInfo;
            this._triggerSortChanged(this._sortInfo);
        } else if (event.type === 'COLUMN_STATE') {
            this._saveState(event.payload);
        } else if (event.type === 'SET_THREAD_ENTRY_LIST') {
            this.threadEntryList = event.payload;
        } else if (event.type === 'SET_LOADING_STATUS') {
            this.reloading = event.payload;
            if (this._changeDetectorRef) {
                this._changeDetectorRef.detectChanges();
            }
        } else if (event.type === 'LOAD_GRID_GROUP_NO_DATA') {
            this._changeNoDataStyle(event.payload === 0);
        }
    }

    private _changeNoDataStyle(noData) {
        if (noData) {
            this.noDataStyle = 'flex';
        } else {
            this.noDataStyle = 'none';
        }
        if (this._changeDetectorRef) {
            this._changeDetectorRef.detectChanges();
        }
    }

    private _actionMessageHandler(action) {
        if (this.rowModelType === 'clientSide') {
            if (!this._gridApi) {
                return;
            }
            if (action.type === ResearchScreenActionTypes.SET_LAYOUT_COLLAPSE) {
                // Fixed for TAM-23366： The columns cannot auto-fit after collapsing Refine By panel
                // TODO: Need to figurte out a better solution to fix the issue.,
                setTimeout(() => {
                    this._gridApi.sizeColumnsToFit();
                }, 1000);
            } else if (action.type === DELETE_SIDENOTE_SUCCESS) {
                const params = {
                    rowNodes: this._gridApi.getSelectedNodes(),
                    force: true
                };
                this._gridApi.refreshCells(params);
                this._changeDetectorRef.detectChanges();
            }
        } else {
            this.gridServerSideAction$.next(action);
        }
    }

    private _addSideNote(threadEntry) {
        const _noteOption = new NoteDialogOpenOptions();

        const sidenoteInfo = this._noteService.getSidenoteInfoBySettingRule(threadEntry.notes, threadEntry.threadEntryTotalNotesInThread);
        if (sidenoteInfo) {
            _noteOption.entryId = sidenoteInfo.entryId;
            _noteOption.entryTypeId = sidenoteInfo.entryTypeId;
        } else {
            _noteOption.entryId = threadEntry.threadEntryThreadId;
        }

        _noteOption.openType = NoteDialogType.AddSideNote;
        _noteOption.minimizable = true;
        _noteOption.entityFieldEditable = this._isEditable(threadEntry);
        this._noteDialogService.dialogOpen$.next(_noteOption);
    }

    private _appendEntities() {
        const _noteOption = new AppendEntitiesDialogOpenOptions();
        _noteOption.minimizable = true;
        _noteOption.selectedItems = this._selectedItems;
        _noteOption.openType = AppendEntitiesDialogType.AppendEntities;
        this._appendEntitiesDialogService.dialogOpen$.next(_noteOption);
    }

    private _changeSelect(item: ThreadEntry, index: number) {
        this.selectedIndexes.clear();
        this.selectedIndex = index;
        this.selectedIndexes.add(this.selectedIndex);
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setSelectedIndexAction,
            payload: {
                index: index,
                id: item.id,
            }
        });
    }

    private _changeSelectStyle() {
        const selectedSet = this.selectedIndexes;
        this._gridApi.forEachNode(function (node) {
            if (selectedSet.has(node.rowIndex)) {
                node.setSelected(true);
            } else {
                node.setSelected(false);
            }
        });
        if (this._changeDetectorRef) {
            this._changeDetectorRef.detectChanges();
        }
    }

    private _copyLink(threadEntry) {
        const entryClass = threadEntry.parentEntry.entryClass;
        this._noteService.shareNote(threadEntry.threadEntryThreadId, entryClass);
    }

    private _editEvent(data) {
        const _noteOption = new CalendarDialogOpenOptions();
        _noteOption.openType = CalendarDialogType.EditEvent;
        _noteOption.entryId = data.threadEntryThreadId;
        _noteOption.isPluginInEditEventMode = false;
        _noteOption.minimizable = true;
        this._calendarDialogService.dialogOpen$.next(_noteOption);
    }

    private _editNote(threadEntry) {
        const _noteOption = new NoteDialogOpenOptions();
        _noteOption.entryId = threadEntry.id;
        if (threadEntry.threadEntryThreadPosition > 0) {
            _noteOption.openType = NoteDialogType.EditSideNote;
        } else {
            _noteOption.openType = NoteDialogType.EditNote;
        }
        _noteOption.minimizable = true;
        _noteOption.entityFieldEditable = this._isEditable(threadEntry);
        this._noteDialogService.dialogOpen$.next(_noteOption);
    }

    private _delete(threadEntry) {
        const content: string[] = [];
        if (this._showAsMode === 0 && threadEntry.threadEntryThreadPosition !== 0) {
            content.push('Are you sure you want to delete this sidenote?');
            content.push('Any attachments will also be deleted.');
        } else {
            content.push('Are you sure you want to delete this note?');
            content.push('Any attachments will be deleted.');
        }
        const cancelBtn: AlertButton = {
            text: 'Cancel',
            type: AlertBtnTypes.tertiary
        };
        const confirmButton: AlertButton = {
            text: 'Delete',
            type: AlertBtnTypes.destructive
        };
        const subscription = this._alertWindow.
            custom('Delete confirmation required', content, cancelBtn, confirmButton)
            .subscribe((result: boolean) => {
                if (result) {
                    this._store.dispatch({
                        type: DELETE_NOTE,
                        payload: {
                            id: threadEntry.id,
                            componentId: 'snippet thread list'
                        }
                    });
                }
                subscription.unsubscribe();
            });
    }

    private _deleteNotes(deleteThreadEntryIds) {
        const content: string[] = [];
        content.push('Are you sure you want to delete these notes?');
        content.push('Any attachments or sidenotes will also be deleted.');
        const cancelBtn: AlertButton = {
            text: 'Cancel',
            type: AlertBtnTypes.tertiary
        };
        const confirmButton: AlertButton = {
            text: 'Delete',
            type: AlertBtnTypes.destructive
        };
        const subscription = this._alertWindow.
            custom('Delete confirmation required', content, cancelBtn, confirmButton)
            .subscribe((result: boolean) => {
                if (result) {
                    this._store.dispatch({
                        type: DELETE_NOTES,
                        payload: {
                            ids: deleteThreadEntryIds,
                            componentId: 'top thread list'
                        }
                    });
                }
                this._changeDetectorRef.detectChanges();
                subscription.unsubscribe();
            });
    }

    private _ensureSelectedItemVisible(threadEntry) {
        setTimeout(() => {
            let index = 0;
            this._gridApi.forEachNode((node) => {
                if (node.data.id === threadEntry.id) {
                    index = node.rowIndex;
                    node.setSelected(true);
                } else {
                    node.setSelected(false);
                }
            });
            this.selectedIndexes.clear();
            this.selectedIndex = index;
            this.selectedIndexes.add(this.selectedIndex);
            this._gridApi.setFocusedCell(index, this.columnDefs[0].colId);
            this._gridApi.ensureIndexVisible(index, 'top');
            if (!this._changeDetectorRef['destroyed']) {
                this._changeDetectorRef.detectChanges();
            }
        }, 0);
    }

    private _isEditable(threadEntry) {
        const flag = threadEntry.notes.find(note => {
            return note.editable === false;
        });
        if (flag) {
            return false;
        } else {
            return true;
        }

    }

    private _getAGGridColumnsByGeneralGridColumns(columns) {
        const agGridColumns = [];
        if (columns && columns.length > 0) {
            const gridColumns = JSON.parse(columns);
            gridColumns.forEach(column => {
                if (column) {
                    const columnState = {
                        colId: column.colId,
                        width: column.width,
                        hide: column.hide,
                    };
                    agGridColumns.push(columnState);
                }
            });
        }
        return agGridColumns;
    }

    private _gridColumnAutoFit() {
        if (this._gridApi) {
            this._gridApi.refreshClientSideRowModel();
            this._gridApi.sizeColumnsToFit();
            this._changeDetectorRef.detectChanges();
        }
    }

    private _getGeneralGridColumnFormatByAGGridColumns(agGridColumns) {
        const gridColumns = [];
        agGridColumns.forEach(column => {
            if (column) {
                const gridColumnInfo = new GridColumnInfo();
                gridColumnInfo.colId = column.colId;
                gridColumnInfo.hide = column.hide;
                gridColumnInfo.width = column.width;

                gridColumns.push(gridColumnInfo);
            }
        });
        return gridColumns;
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.stateful = false;
        this.contextMenuConfig.forceRefresh = true;
        this.contextMenuConfig.events$.subscribe(event => this._onMenuSelect(event));
    }

    private _onMenuSelect(event) {
        const type = +event.payload.id;
        const threadEntry = event.payload.data;
        switch (type) {
            case 0:
                this._openNoteInNewTab(threadEntry);
                break;
            case 1:
                this._openNoteInNewWindow(threadEntry);
                break;
            case 2:
                this._addSideNote(threadEntry);
                break;
            case 3:
                if (threadEntry.threadEntryEntryClass === 0) {
                    // Edit Event
                    this._editEvent(threadEntry);
                } else {
                    // Edit Note
                    this._editNote(threadEntry);
                }
                break;
            case 4:
                this._copyLink(threadEntry);
                break;
            case 5:
                // Email Note
                this._shareNote(threadEntry);
                break;
            case 6:
                // Delete
                if (this._hasDeletePermissionThreadEntryIds && this._hasDeletePermissionThreadEntryIds.length > 0) {
                    this._deleteNotes(this._hasDeletePermissionThreadEntryIds);
                    this._hasDeletePermissionThreadEntryIds = [];
                } else {
                    this._delete(threadEntry);
                }

                break;
            case 7:
                // Full View
                this._triggerFullView(threadEntry);
                break;
            case 8:
                // Print
                this._printNotes();
                break;
            case 9:
                this._appendEntities();
                break;
            default:
                break;
        }
    }

    private _onSubscribeActions(action: any) {
        if (action.type === 'RELOAD') {
            this._reload(action.payload);
        } else if (action.type === 'FOCUS') {
            if (this.rowModelType === 'clientSide') {
                // get the index of last selected item
                let nextIndex = 0;
                Array.from(this.selectedIndexes.values()).forEach(index => {
                    if (index > nextIndex) {
                        nextIndex = index;
                    }
                });
                this._gridApi.setFocusedCell(nextIndex, this.columnDefs[0].colId);
            } else {
                this.gridServerSideAction$.next({
                    type: 'FOCUS'
                });
            }
        } else if (action.type === 'TAB_CLICK') {
            if (this.rowModelType === 'clientSide') {
                this._gridApi.sizeColumnsToFit();
            } else {
                this.gridServerSideAction$.next({
                    type: 'TAB_CLICK'
                });
            }
        } else if (action.type === PrintActions.PRINT) {
            this._printNotes();
        }

        this._changeDetectorRef.detectChanges();
    }

    private _onSubscribeGridGroupLayout(data) {
        if (data) {
            this.rowModelType = data.rowModelType || 'clientSide';
            const expandGroups = data.expandGroups;
            const groupSortColumns = data.groupSortColumns;
            this.gridServerSideLayout = {
                expandGroups,
                groupSortColumns
            };
            this.groupContextMenuConfig.items[0].disabled = this.rowModelType === 'serverSide';
        }
    }

    private _onSubscribeNoteMsg(msg: string) {
        if (msg.indexOf(DELETE_ATTACHMENT_SUCCESS) > -1) {
            if (this.rowModelType === 'clientSide') {
                if (!this._gridApi) {
                    return;
                }
                // TODO: Need to improve to pass the accurate value by object
                const attachId = msg.substring(msg.lastIndexOf('-') + 1);
                this._gridApi.getSelectedNodes().forEach(node => {
                    if (node.data.attachments.has(attachId)) {
                        node.data.attachments.delete(attachId);
                    }
                });
                const params = {
                    rowNodes: this._gridApi.getSelectedNodes(),
                    force: true
                };
                this._gridApi.refreshCells(params);
            } else {
                this.gridServerSideAction$.next({
                    type: 'DELETE_ATTACHMENT_SUCCESS',
                    payload: msg
                });
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    private _onSubscribeThreadList(threadEntryList) {
        if (threadEntryList && threadEntryList.selectedIndex) {
            const threadEntry = threadEntryList.items[threadEntryList.selectedIndex.index];
            this._selectedItem = threadEntry;
            this._redrawRows();
            this._ensureSelectedItemVisible(threadEntry);
        }

        if (threadEntryList && threadEntryList.currentPageIndex) {
            this._currentPageIndex = threadEntryList.currentPageIndex;
        }
        this._changeDetectorRef.detectChanges();
    }

    private _onSubscribeThreadListItem(items: DataList<ThreadEntry>) {
        // save research page is group by note
        // Display no data
        this._changeNoDataStyle(items.length === 0 && items.totalCount === 0);
        this.threadEntryList = items;
        if (this.rowModelType === 'serverSide') {
            return;
        }
        // snip view switch top/side view
        if (!this.reloading && !this.loadingMore) {
            this._gridApi.setRowData(items);
        }
        // reloading the data
        if (this.reloading) {
            this._gridApi.setRowData(items);
            this.reloading = this._noSetLoading;
            this._noSetLoading = false;
            if (items && items.length > 0) {
                // need to select the first item by default after reload
                this.selectedIndex = 0;
                this.selectedIndexes.add(this.selectedIndex);
                this._gridApi.forEachNode((node) => {
                    if (node.rowIndex === 0) {
                        node.setSelected(true); // this will trigger select change
                    } else {
                        node.setSelected(false);
                    }
                });
                this._gridApi.setFocusedCell(0, this.columnDefs[0].colId);
            }
        }

        if (this.loadingMore) {
            this.loadingMore = false;
            const startRowIndex = (this._currentPageIndex - 1) * DEFAULT_PAGE_SIZE;
            const endRowIndex = this._currentPageIndex * DEFAULT_PAGE_SIZE;
            this._gridApi.updateRowData({
                add: items.slice(startRowIndex, endRowIndex)
            });
        }

        this._changeDetectorRef.detectChanges();
    }

    private _openNoteInNewTab(threadEntry) {
        const noteLink = this._noteService.getShareNoteLink(threadEntry.threadEntryThreadId, threadEntry.threadEntryEntryClass);
        window.open(noteLink, '_blank');
    }

    private _openNoteInNewWindow(threadEntry) {
        const marginLeft = (window.screen.availWidth - 800) / 2;
        const marginTop = (window.screen.availHeight - 800) / 2;
        const noteLink = this._noteService.getShareNoteLink(threadEntry.threadEntryThreadId, threadEntry.threadEntryEntryClass);
        window.open(noteLink, '_blank', 'width=800,height=800,top=' + marginTop + ',left=' + marginLeft);
    }

    private _redrawRows() {
        if (this._gridApi) {
            this._gridApi.redrawRows();
        }
    }

    private _reload(payload) {
        const queryInfo = payload.queryInfo;
        this._showAsMode = payload.showAsMode;
        this.reloading = true;
        this._currentPageIndex = 1;
        this.selectedIndexes.clear();
        this.selectedIndex = null;
        this._selectedItem = null;
        this._queryInfo = queryInfo;
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setQueryInfoAction,
            payload: this._queryInfo
        });
        if (this.rowModelType === 'clientSide') {
            this._store.dispatch({
                prefix: this.config.keyInStore,
                type: this.config.reloadAction,
                payload: {
                    pageIndex: 1,
                    pageSize: DEFAULT_PAGE_SIZE,
                    showAsMode: this._showAsMode,
                    ...this._queryInfo
                }
            });
        } else {
            this.gridServerSideAction$.next({
                type: 'RELOAD'
            });
        }
    }

    private _restoreState() {
        this._store.pipe(
            select(this.config.gridInfoSelector),
            take(1)
        ).subscribe(columnState => this._columnState = columnState);

        if (this._columnState && JSON.stringify(this._columnState) !== '{}') {
            if (this._columnState.length !== 0) {
                const agGridColumnsState = this._getAGGridColumnsByGeneralGridColumns(this._columnState);
                this._gridColumnApi.applyColumnState({ state: agGridColumnsState, applyOrder: true, });
            }
        }
    }

    private _saveState(column?) {
        const agGridColumns = column || this._gridColumnApi.getColumnState();
        const gridColumns = this._getGeneralGridColumnFormatByAGGridColumns(agGridColumns);
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setGridStatusAction,
            payload: JSON.stringify(gridColumns)
        });
        this._triggerGridInfoChanged(gridColumns);
    }

    private _shareNote(threadEntry) {
        const entryClass = threadEntry.threadEntryEntryClass;
        const contact = this._storeQuerier.queryBySelector(systemCurrentContactSelector);
        const noteLink = this._noteService.getShareNoteLink(threadEntry.threadEntryThreadId, entryClass);
        const emailBody = this._noteService.getShareNoteEmailBody(contact.name, threadEntry.threadEntrySubject, noteLink);
        this._noteService.emailNote(threadEntry.threadEntryCalculatedSubject, emailBody);
    }

    private _triggerFullView(threadEntry) {
        this.config.events$.next({
            type: 'MAXIMIZE',
            payload: threadEntry
        });
    }

    /**
     *  print selected thread list.
     *
     * @private
     * @memberof TopThreadListComponent
     */
    private _printNotes(): void {
        this._printService.printThreads(this.threadEntryList, this.selectedIndexes);
    }

    private _triggerGridInfoChanged(gridColumnInfo: GridColumnInfo[]) {
        this.config.events$.next({
            type: 'GRIDINFOCHANGED',
            payload: gridColumnInfo
        });
    }

    private _triggerSortChanged(sortInfo: any) {
        this.config.events$.next({
            type: 'SORTCHANGEED',
            payload: sortInfo
        });
    }
}
